import Cookie from "js-cookie";
import { getDomain } from "@/utils/fetch";

const CookieSet = Cookie.set;
const CookieRemove = Cookie.remove;

Cookie.set = (key, value, options) => {
  const domain = process?.env?.NODE_ENV === "development" ? "" : getDomain();
  CookieSet(key, value, { domain, ...options });
};

Cookie.remove = (key, options) => {
  const domain = process?.env?.NODE_ENV === "development" ? "" : getDomain();
  CookieRemove(key, { domain, ...options });
};

export default Cookie;
